import {
	Component,
	EventEmitter,
	Input,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { patientColors } from "@app/definitions/types"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "app-color-select",
	imports: [COMMON_IMPORTS, LangValPipe],
	styles: [
		`
			button {
				height: 20px;
				width: 20px;
				border: 1px solid #ccc;
			}
			.popup {
				div {
					display: flex;
					width: 200px;
					flex-wrap: wrap;
				}
			}
		`,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<button
			class="btn"
			[style.backgroundColor]="value"
			(click)="isOpen = true"
		></button>
		@if (isOpen) {
			<div class="popup">
				<div>
					<button
						class="btn"
						(click)="handleClick()"
					>
						{{ "none" | langVal }}
					</button>
				</div>
				<div>
					@for (color of colors; track color) {
						<button
							class="btn"
							(click)="handleClick(color)"
							[style.backgroundColor]="color"
						></button>
					}
				</div>
			</div>
		}
	`,
})
export class ColorSelectComponent {
	@Input() value: string = ""
	@Output() onChange = new EventEmitter()

	isOpen: boolean = false
	colors = patientColors

	handleClick(color: string = "") {
		this.value = color
		this.isOpen = false
		this.onChange.emit(color)
	}
}
